module.exports = __webpack_public_path__ + "static/media/i-nani.d815612d.mp3";